import {
  APP_INITIALIZER,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';
import { ShareviewHealthConfigurationLoaderService } from '../../services';

function configurationInitFactory(
  configurationLoaderService: ShareviewHealthConfigurationLoaderService
): () => Promise<unknown> {
  return () => {
    return configurationLoaderService.loadConfiguration();
  };
}

export function provideConfigurationLoader(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ShareviewHealthConfigurationLoaderService },
    {
      provide: APP_INITIALIZER,
      useFactory: configurationInitFactory,
      deps: [ShareviewHealthConfigurationLoaderService],
      multi: true,
    },
  ]);
}
